import { RowData } from "@models/DataTable"
import dayjs from "dayjs"

export interface IRowUnit {
  projectId: number
  projectName: string
  floorName: string
  amountMonthly: number
  amountPerSquareMeter: number
  size: number
  orgTenantId: number
  orgTenantBusinessName: string
  orgTenantLegalName: string
  statusName: string
  unitTypeName: string
  startDate?: Date
  expiredDate?: Date
  description: string
}

export class RowUnitModel extends RowData implements IRowUnit {
  projectId: number
  projectName: string
  floorName: string
  amountMonthly: number
  amountPerSquareMeter: number
  size: number
  orgTenantId: number
  orgTenantBusinessName: string
  orgTenantLegalName: string
  statusName: string
  unitTypeName: string
  commencementDate?: Date
  expiredDate?: Date
  moveInDate?: Date
  moveOutDate?: Date
  otherLA?: any
  description: string
  constructor() {
    super()
    this.projectId = 0
    this.projectName = ""
    this.floorName = ""
    this.amountMonthly = 0
    this.amountPerSquareMeter = 0
    this.size = 0
    this.orgTenantId = 0
    this.orgTenantBusinessName = ""
    this.orgTenantLegalName = ""
    this.statusName = ""
    this.unitTypeName = ""
    this.commencementDate = undefined
    this.expiredDate = undefined
    this.moveInDate = undefined
    this.moveOutDate = undefined
    this.otherLA = {}
    this.description = ""
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new RowUnitModel(), obj)
    newObj.name = obj.unitName
    newObj.amountMonthly = obj.monthly
    newObj.amountPerSquareMeter = obj.per
    newObj.commencementDate = obj.leaseAgreement?.find(
      (item) =>
        item?.expiryDate >= dayjs().toJSON() &&
        item?.commencementDate <= dayjs().toJSON()
    )?.commencementDate
    newObj.expiredDate = obj.leaseAgreement?.find(
      (item) =>
        item?.expiryDate >= dayjs().toJSON() &&
        item?.commencementDate <= dayjs().toJSON()
    )?.expiryDate
    newObj.moveInDate = obj.leaseAgreement?.find(
      (item) =>
        item?.expiryDate >= dayjs().toJSON() &&
        item?.commencementDate <= dayjs().toJSON()
    )?.moveInDate
    newObj.moveOutDate = obj.leaseAgreement?.find(
      (item) =>
        item?.expiryDate >= dayjs().toJSON() &&
        item?.commencementDate <= dayjs().toJSON()
    )?.moveOutDate
    newObj.otherLA = obj.leaseAgreement?.find(
      (item) => item?.commencementDate > dayjs().toJSON()
    )
    return newObj
  }

  public static assigns<T>(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}
// interface UnitFloor {
//   id?: number
//   unitId?: number
//   floorName?: string
//   constructionSize?: number
//   usableSize?: number
// }

export class UnitUpdateMasterModel {
  id?: number
  projectId?: number
  buildingCode?: string
  towerId?: any
  // unitFloor?: UnitFloor[]
  unitName: string
  productTypeId?: number
  constructionSize?: number
  usableSize?: number
  statusId?: number
  unitFacilityIds?: number[]
  unitDesignIds?: number[]
  constructor() {
    this.unitName = ""
  }
}

export class UnitUpdateModel {
  id?: number
  statusId?: number
  viewId?: number
  kitchenViewId?: number
  motobikePark?: number
  carPark?: number
  balcony?: number
  helperRoom?: number
  balconySize?: number
  laundryArea?: number
  bedRoom?: number
  bathRoom?: number
  livingRoom?: number
  ownerShipStatus?: string
  legalStatus?: string
  interior?: string
  unitFacilityIds?: number[]
}
export class UnitModel {
  floor: string

  constructor() {
    this.floor = ""
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new UnitModel(), obj)
    // newObj.floor = obj.unitFloor.map((i) => i?.floorName).join(", ")
    newObj.hasBalconyArea = obj.hasBalconyArea.toString()
    newObj.hasLaundryArea = obj.hasLaundryArea.toString()
    newObj.towerId = obj.floor?.towerId
    return newObj
  }

  public static assigns<T>(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}
